export function setFacebook({ state, action }) {
  return { ...state, facebookId: action.facebookId, facebookLinked: action.linked };
}

export function openFacebookAccountAlreadyLinkedPopup({ state }) {
  return { ...state, facebookAccountAlreadyLinkedPopupOpen: true };
}

export function closeFacebookAccountAlreadyLinkedPopup({ state }) {
  return { ...state, facebookAccountAlreadyLinkedPopupOpen: false };
}

export function closeFacebookLoginNotPossibleErrorPopup({ state }) {
  return { ...state, facebookLoginNotPossiblePopupOpen: false };
}

export function openFacebookLoginNotPossibleErrorPopup({ state }) {
  return { ...state, facebookLoginNotPossiblePopupOpen: true };
}
